import { inject, provide } from 'vue';
import { identity } from '@nzyme/utils/functions/identity.js';
/**
 * @__NO_SIDE_EFFECTS__
 */
export function defineContext(name, context) {
    return {
        name,
        setup: context || identity,
        symbol: Symbol(name),
    };
}
/** Creates a context instance and provides it to descendant components via Vue's provide/inject. */
export function provideContext(context, ...params) {
    const instance = context.setup(...params);
    provide(context.symbol, instance);
    return instance;
}
/** Injects a context provided by an ancestor component. */
export function injectContext(context, opts) {
    const instance = inject(context.symbol, null);
    if (!instance) {
        if (opts?.optional) {
            return null;
        }
        throw new Error(`Context ${context.name} was not registered`);
    }
    return instance;
}
//# sourceMappingURL=context.js.map